export class UnloadingPointTruck {
  transportId: number;
  vehiclePlate: string;
  carrier: string;
  state: string;
  lastUpdate: string | null;
  executionOrder: number | null;
  currentAction: string | null;
  urgent: number;

  constructor(
    transportId: number = 0,
    vehiclePlate: string = '',
    carrier: string = '',
    state: string = '',
    lastUpdate: string | null = null,
    executionOrder: number | null = null,
    currentAction: string | null = null,
    urgent: number = 0
  ) {
    this.transportId = transportId;
    this.vehiclePlate = vehiclePlate;
    this.carrier = carrier;
    this.state = state;
    this.lastUpdate = lastUpdate;
    this.executionOrder = executionOrder;
    this.currentAction = currentAction;
    this.urgent = urgent;
  }
}

/**
 * Domain aggregate for each unloading point in the trucks-in-plant response.
 */
export class UnloadingPoint {
  lastPosition: string;
  trucksCount: number;
  trucks: UnloadingPointTruck[];

  constructor(
    lastPosition: string = '',
    trucksCount: number = 0,
    trucks: UnloadingPointTruck[] = []
  ) {
    this.lastPosition = lastPosition;
    this.trucksCount = trucksCount;
    this.trucks = trucks;
  }
}

/**
 * Domain aggregate for GET /entries/workshop/trucks-in-plant.
 */
export class UnloadingPointInfo {
  timestamp: string;
  workshop: string;
  unloadingPoints: UnloadingPoint[];
  totalTrucks: number;

  constructor(
    timestamp: string = '',
    workshop: string = '',
    unloadingPoints: UnloadingPoint[] = [],
    totalTrucks: number = 0
  ) {
    this.timestamp = timestamp;
    this.workshop = workshop;
    this.unloadingPoints = unloadingPoints;
    this.totalTrucks = totalTrucks;
  }
}
